import { withFormsy, propTypes } from "formsy-react";
import React from "react";
import {
  FormGroup,
  FormFeedback,
  Label,
  FormText,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input
} from "reactstrap";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Spinner } from "../../Shared";
import { MdDateRange } from "react-icons/md";
import { dateTimeutils } from "../../../_utils";

class CustomInput extends React.Component {
  render() {
    return (
      <InputGroup>
        <Input
          onFocus={this.props.onClick}
          onChange={this.props.onChange}
          readOnly={true}
          disabled={this.props.disabled}
          value={this.props.value}
        />
        <InputGroupAddon
          onClick={this.props.onClick}
          className={this.props.disabled ? "disabled" : ""}
          addonType="append"
        >
          <InputGroupText>
            <MdDateRange />
          </InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

export class DatePickerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: null
    };
    this.changeValue = this.changeValue.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultValue &&
      nextProps.defaultValue !== this.props.defaultValue
    ) {
      this.setState({
        date: dateTimeutils.formatDateTime(nextProps.defaultValue)
      });
      this.props.setValue(dateTimeutils.formatDateTime(nextProps.defaultValue));
    }
  }

  changeValue(date) {
    this.setState({ date });
    this.props.setValue(date);
  }

  render() {
    const errorMessage = this.props.getErrorMessage();
    const { date } = this.state;
    const {
      showRequired,
      showError,
      showLoader,
      name,
      title,
      isPristine,
      infoText,
      hasValue,
      isRequired,
      disabled,
      maxDate,
      minDate,
      label,
      isTime,
      isStart,
      isEnd,
      startDate,
      endDate,
      isNotClearable
    } = this.props;
    const hasError =
      !isPristine() && (showError() || (isRequired() && !hasValue()));

    return (
      <FormGroup>
        {title && (
          <Label className={isRequired() && "required"} htmlFor={name}>
            {title}
          </Label>
        )}

        <Datepicker
          customInput={<CustomInput />}
          selected={date}
          maxDate={maxDate}
          selectsStart={isStart}
          selectsEnd={isEnd}
          startDate={startDate}
          endDate={endDate}
          minDate={minDate}
          onChange={this.changeValue}
          label={label}
          disabled={disabled}
          className="form-control"
          isClearable={isNotClearable ? false : true}
          showTimeSelect={isTime}
          timeFormat="HH:mm"
          timeCaption="time"
          timeIntervals={15}
          dateFormat="MMMM d, yyyy h:mm aa"
        />

        {infoText ? <FormText>{infoText}</FormText> : ""}
        {hasError ? (
          <FormFeedback style={{ display: "inline" }}>
            {errorMessage}
          </FormFeedback>
        ) : (
          ""
        )}
        {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
        {showLoader ? <Spinner /> : ""}
      </FormGroup>
    );
  }
}

DatePickerComponent.propTypes = {
  ...propTypes
};

const MyInput = withFormsy(DatePickerComponent);

export { MyInput as DatePicker };
